import { useState } from "react";
import { useLocation } from "wouter";
import { useAuth } from "../hooks/useAuth";
import { ApiError } from "../api/client";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const [, navigate] = useLocation();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0f172a" }}>
      <div style={{ background: "#1e293b", padding: "2rem", borderRadius: "8px", width: "100%", maxWidth: "380px" }}>
        <h1 style={{ color: "#f1f5f9", marginBottom: "1.5rem", fontSize: "1.5rem" }}>Sign in</h1>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "1rem" }}>
            <label style={{ color: "#94a3b8", fontSize: "0.875rem", display: "block", marginBottom: "0.25rem" }}>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
              style={{ width: "100%", padding: "0.5rem 0.75rem", background: "#0f172a", border: "1px solid #334155", borderRadius: "4px", color: "#f1f5f9", fontSize: "1rem", boxSizing: "border-box" }} />
          </div>
          <div style={{ marginBottom: "1.5rem" }}>
            <label style={{ color: "#94a3b8", fontSize: "0.875rem", display: "block", marginBottom: "0.25rem" }}>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
              style={{ width: "100%", padding: "0.5rem 0.75rem", background: "#0f172a", border: "1px solid #334155", borderRadius: "4px", color: "#f1f5f9", fontSize: "1rem", boxSizing: "border-box" }} />
          </div>
          {error && <p style={{ color: "#f87171", fontSize: "0.875rem", marginBottom: "1rem" }}>{error}</p>}
          <button type="submit" disabled={loading}
            style={{ width: "100%", padding: "0.625rem", background: "#1d4ed8", color: "#fff", border: "none", borderRadius: "4px", fontSize: "1rem", cursor: "pointer" }}>
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p style={{ color: "#64748b", textAlign: "center", marginTop: "1rem", fontSize: "0.875rem" }}>
          No account? <a href="/register" style={{ color: "#3b82f6" }}>Register</a>
        </p>
      </div>
    </div>
  );
}
